/* Carnis – sparing i abonnementet (okt. 2026, v1). Utvider assets/carnis-kjop.js uten å endre den.
   Lastes fra snippets/carnis-kjop.liquid der abonnementet vises (produktsidene og kolleksjonen).
   Etter hver oppdatering av kjøpsvalget (hendelsen «carnis:kjop») og ved oppstart:
   - Kvitteringen ([data-cks-lines]): én linje per valgt produkt, «3 × Storfetalg», engangspris gjennomstreket og
     abonnementspris, regnet ut fra antallet i velgerne og prisene i konfigurasjonen (Shopify + Appstle-planen).
   - «Du sparer X %» ([data-ck-abo-save]) for hele leveringen, rundet ned (nov. 2026: prosent, ikke kroner).
   - Knappen «Abonner – [total]» får førprisen gjennomstreket (.cks-was).
   - Kjøpslinja nederst: «Abonnement · 3 varer · 777 kr · 7 % billigere».
   - «Velg abo →» i engangsvalget ([data-ck-abo-pick]) velger abonnementet (samme antall når det er 3 eller flere).
   Sparing = sum over linjene av antall × (engangspris − abonnementspris), aldri under 0. */
(function () {
  'use strict';
  if (window.CarnisSpar) return;
  window.CarnisSpar = { version: 1 };

  var NB = ' ';
  function fmt(c) {
    if (window.CarnisKjop && typeof window.CarnisKjop.fmt === 'function') return window.CarnisKjop.fmt(c);
    var v = Math.round(Number(c) || 0), neg = v < 0;
    if (neg) v = -v;
    var kr = Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, NB), ore = v % 100;
    return (neg ? '−' : '') + kr + (ore ? ',' + ('0' + ore).slice(-2) : '') + NB + 'kr';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function cfgOf(el) {
    if (el.__cksCfg) return el.__cksCfg;
    var c = {};
    try { c = JSON.parse((el.querySelector('[data-ck-config]') || {}).textContent || '{}'); } catch (e) { c = {}; }
    el.__cksCfg = c;
    return c;
  }

  // Ren utregning (testes i node): items = [{ name, once, sub, available }], q = { key: antall }
  function calc(items, q, min) {
    var r = { n: 0, total: 0, was: 0, save: 0, lines: [] };
    (items || []).forEach(function (it) {
      var n = it.available === false ? 0 : Math.max(0, parseInt(q[it.key], 10) || 0);
      if (!n) return;
      var sub = Number(it.sub) || 0;
      var once = Math.max(Number(it.once) || 0, sub);
      var line = { key: it.key, name: it.name, q: n, total: n * sub, was: n * once };
      r.n += n;
      r.total += line.total;
      r.was += line.was;
      r.lines.push(line);
    });
    r.save = Math.max(0, r.was - r.total);
    r.pct = r.was > 0 ? Math.floor(r.save * 100 / r.was) : 0;
    r.valid = r.n >= (Number(min) || 3);
    return r;
  }
  window.CarnisSpar.calc = calc;

  function paint(el) {
    if (!el || !el.querySelector || !el.querySelector('[data-cks]')) return;
    var cfg = cfgOf(el);
    var abo = cfg.abo;
    if (!abo || !abo.items) return;
    var q = {};
    abo.items.forEach(function (it) {
      var inp = el.querySelector('[data-ck-abo-q="' + it.key + '"]');
      q[it.key] = inp ? inp.value : 0;
    });
    // Samme rekkefølge som radene på siden (produktet på siden først)
    var order = qsa(el, '[data-ck-abo-row]').map(function (row) { return row.getAttribute('data-ck-abo-row'); });
    var items = abo.items.slice().sort(function (a, b) { return order.indexOf(a.key) - order.indexOf(b.key); });
    var r = calc(items, q, abo.min);

    // Kvitteringen: én linje per produkt
    qsa(el, '[data-cks-lines]').forEach(function (ul) {
      ul.innerHTML = r.lines.map(function (l) {
        return '<li class="cks__line"><span class="cks__name">' + l.q + NB + '×' + NB + esc(l.name) + '</span>' +
          '<span class="cks__amt">' + (l.was > l.total ? '<s>' + fmt(l.was) + '</s> ' : '') + '<b>' + fmt(l.total) + '</b></span></li>';
      }).join('');
      ul.hidden = !r.lines.length;
    });
    // Total med førpris
    qsa(el, '[data-ck-abo-total]').forEach(function (b) { b.textContent = fmt(r.total); });
    qsa(el, '[data-ck-abo-was]').forEach(function (w) { w.textContent = fmt(r.was); w.hidden = !(r.save > 0); });
    // «Du sparer X kr per levering»
    qsa(el, '[data-ck-abo-save]').forEach(function (s) {
      s.innerHTML = 'Du sparer <b>' + r.pct + NB + '%</b>';
      s.hidden = !(r.pct > 0 && r.valid);
    });
    // Førpris på «Abonner»-knappen (bare når knappen viser totalen)
    var btn = el.querySelector('[data-ck-abo-add]');
    var lab = el.querySelector('[data-ck-abo-add-label]');
    if (lab) {
      qsa(lab, '.cks-was').forEach(function (x) { x.parentNode.removeChild(x); });
      var last = lab.lastChild;
      while (last && last.nodeType === 3 && !/\S/.test(last.nodeValue)) { lab.removeChild(last); last = lab.lastChild; }
      // Nov. 2026: ingen gjennomstreket pris på knappen (kan leses som førpris); sparingen står i kvitteringen
      if (false && btn && !btn.disabled && r.valid && r.save > 0) {
        var s = document.createElement('s');
        s.className = 'cks-was';
        s.setAttribute('aria-hidden', 'true');
        s.textContent = fmt(r.was);
        lab.appendChild(document.createTextNode(' '));
        lab.appendChild(s);
      }
    }
    // Kjøpslinja nederst (produktsiden)
    if (el.getAttribute('data-mode') === 'sub' && el.id) {
      qsa(document, '[data-ck-sticky]').forEach(function (st) {
        if (st.getAttribute('data-ck-for') !== el.id) return;
        var txt = 'Abonnement · ' + r.n + ' ' + (r.n === 1 ? 'vare' : 'varer') + ' · ' + fmt(r.total) + (r.pct >= 5 && r.valid ? ' · ' + r.pct + NB + '% billigere' : '');
        qsa(st, '[data-ck-sticky-meta]').forEach(function (m) { m.textContent = txt; });
      });
    }
  }
  window.CarnisSpar.paint = paint;

  document.addEventListener('carnis:kjop', function (e) { paint(e.target); });

  // «Velg abo →» i engangsvalget: velg abonnementet. Har kunden valgt 3 eller flere krukker, får abonnementet
  // samme antall av produktet på siden.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ck-abo-pick]') : null;
    if (!b) return;
    var el = b.closest('[data-ck]');
    var radio = el && el.querySelector('[data-ck-mode][value="sub"]');
    if (!radio) return;
    e.preventDefault();
    var qIn = el.querySelector('[data-ck-q="once"]');
    var qo = parseInt(qIn ? qIn.value : 1, 10) || 1;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    if (qo > 3) {
      var key = el.getAttribute('data-handle') === 'carnis-organmix' ? 'organmix' : 'talg';
      var inp = el.querySelector('[data-ck-abo-q="' + key + '"]');
      if (inp && !inp.disabled) {
        inp.value = Math.min(qo, Number(inp.getAttribute('max')) || 12);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var opt = el.querySelector('[data-ck-opt="sub"]');
    if (opt) {
      var top = opt.getBoundingClientRect().top;
      if (top < 70 || top > (window.innerHeight || 800) * 0.6) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, window.pageYOffset + top - 90), behavior: reduce ? 'auto' : 'smooth' });
      }
    }
  });
  function boot() { qsa(document, '[data-ck]').forEach(paint); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
